import React from 'react';
import styled from 'styled-components';
import BackButton from 'src/Booking/components/CreateAccountBackButton/BackButton';
import CreateUsernameForm from 'src/Booking/components/CreateUsernameForm/CreateUsernameFormContainer';
import DoctorCardHeader from 'src/Booking/components/DoctorCardHeader';
import LazyLoginModal from 'src/Booking/components/LazyLoginModal';
import { CSS_TRANSITIONS } from 'src/Booking/reducers/SignUpReducer';
import { slideLeftToRightAnimation } from 'src/Booking/utils/transitionAnimation';

/**
 * @param {JSX.Element} __fakeImportLoginModal
 * @param {string} formattedAppointmentTime
 * @param {function} goBackToPatientInfo
 * @param {string} locationId
 * @param {Object} loggedInUser
 * @param {function} onClickLoginLink
 * @param {function} onCloseLoginModal
 * @param {function} onSignInSuccess
 * @param {string} providerId
 * @param {string} returnUrl
 * @param {function} sendMetric
 * @param {boolean} shouldShowLoginModal
 * @returns {JSX.Element}
 * @constructor
 */
const CreateUsernamePageView = ({
    __fakeImportLoginModal,
    cssTransition,
    formattedAppointmentTime,
    locationId,
    loggedInUser,
    onClickLoginLink,
    onCloseLoginModal,
    onSignInSuccess,
    providerId,
    returnUrl,
    sendMetric,
    shouldShowLoginModal,
}) => {
    const userEmail = loggedInUser?.email;
    const canDefaultUserEmail =
        Boolean(loggedInUser?.has_password) && userEmail;
    const defaultEmail = canDefaultUserEmail ? userEmail : null;

    const loginModalProps = {
        defaultEmail,
        onCloseLoginModal,
        onSignInSuccess,
        returnUrl,
        __fakeImportLoginModal,
    };

    return (
        <Wrapper>
            <BackButton sendMetric={sendMetric} />
            <MainContent $cssTransition={cssTransition}>
                <DoctorCardWrapper>
                    <DoctorCardHeader
                        formattedAppointmentTime={formattedAppointmentTime}
                        locationId={locationId}
                        providerId={providerId}
                    />
                </DoctorCardWrapper>
                <CreateUsernameForm
                    data-test="create-username-form"
                    onClickLoginLink={onClickLoginLink}
                />
                {shouldShowLoginModal && (
                    <LazyLoginModal
                        data-test="lazy-login-modal"
                        {...loginModalProps}
                    />
                )}
            </MainContent>
        </Wrapper>
    );
};

const MainContent = styled.div`
    width: 485px;
    max-width: calc(100% - 32px);
    margin: auto;
    ${(p) =>
        p.$cssTransition === CSS_TRANSITIONS.LEFT_TO_RIGHT
            ? slideLeftToRightAnimation
            : ''};
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const DoctorCardWrapper = styled.div`
    display: block;
`;

export default CreateUsernamePageView;
